<template>
  <div>

    <div class="panel">
      <b-button v-b-modal.help-modal>Help</b-button>
    </div>

    <div class="search-conf-panel">
      <label for="filter">Filter</label>
      <b-form-select
        id="filter"
        :options="searchTypes"
        v-model="searchType"
      />
    </div>

    <loading-indicator
      v-if="isLoading"
    />

    <p v-if="message !== null">
      {{message}}
    </p>

    <table v-if="complainees !== null && complainees.length > 0" class="table text-nowrap">
      <thead class="thead-dark">
        <tr>
          <th scope="col">Complainee</th>
          <th scope="col" class="text-right">Unprocessed complaint amount</th>
        </tr>
      </thead>
        <tr
          v-for="complainee in complainees"
          :key="complainee.id"
        >
          <td>
            <player-link :playerId="complainee.id" />
          </td>
          <td class="text-right">
            <router-link
              :to="{name: 'player_in_complaints', params: {playerId: complainee.id}}"
            >
              {{complainee.complaintAmount}}
            </router-link>
          </td>
        </tr>
    </table>

    <b-modal id="help-modal" title="Справка" ok-only ok-title="Close">
      <div class="help">
        <p>
          На данной странице показаны ответчики по жалобам (игроки, на которых другие игроки отправили жалобы).
        </p>
      </div>
    </b-modal>

  </div>
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';
import LoadingIndicator from './LoadingIndicator.vue';
import PlayerLink from './PlayerLink.vue';

const SEARCH_TYPE_ALL       = 0;
const SEARCH_TYPE_IMPORTANT = 1;

export default {
  name: 'ClubsComplainees',

  components: {
    LoadingIndicator,
    PlayerLink,
  },

  data() {
    return {
      searchTypes: [
        { value: SEARCH_TYPE_ALL, text: 'All complainees' },
        { value: SEARCH_TYPE_IMPORTANT, text: 'Important complainees (complaint amount 10 or more)' },
      ],

      searchType: SEARCH_TYPE_IMPORTANT,
      isLoading: false,
      complainees: null,
    };
  },

  computed: {
    message() {
      if(this.complainees !== null && this.complainees.length === 0) {
        return this.getEmptyResultMessage;
      }
      return null;
    },

    getEmptyResultMessage() {
      if(this.searchType === SEARCH_TYPE_IMPORTANT) {
        return 'No important complainees.';
      } 
      return 'No complainees.';
    },
  },

  watch: {
    searchType() {
      this.loadComplainees();
    },
  },

  created() {
    this.loadComplainees();
  },

  methods: {
    loadComplainees() {
      notifier.deleteSenderNotifications(this);

      this.isLoading = true;

      const url = this.getUrl();
      HTTP.get(url)
      .then(response => {
        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        const complainees = data.slice();
        complainees.sort((a, b) => a.id - b.id);
        this.complainees = complainees;
      })
      .catch(e => {
        notifier.showError(e.response.data);
      })
      .finally(() => {
        this.isLoading = false;
      });
    },

    getUrl() {
      if(this.searchType === SEARCH_TYPE_IMPORTANT) {
        return '/clubs/complainees/important';
      }
      return '/clubs/complainees';
    },
  },
};
</script>

<style scoped>
  .panel {
    margin-bottom: 1em;
  }

  .search-conf-panel {
    margin-bottom: 1em;
  }
</style>
